import {Component, ElementRef, HostListener, OnInit, ViewChild, ComponentFactoryResolver, ChangeDetectorRef, NgZone} from '@angular/core';
import {GlobalServices} from '../global.services';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ApiService} from '../api.service';
import {baseUrls} from '../appConstant';
import { UserContactService } from '../services/user-contact.service';
import { Router } from '@angular/router';
import { ChangeDetectionStrategy } from '@angular/compiler/src/compiler_facade_interface';
declare var $: any;


@Component({
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  @ViewChild('loginRef2', {static: true }) loginElement: ElementRef;
  public clickcheck = 0;
  confirmpass = true;
  public auth2: any;
  public registerFormUser: FormGroup;
  public registerFormPartener: FormGroup;
  public errorMessageEmail: string = '';
  public submitted: boolean = false;
  public signupType:string;
  mode: string;
  color: any = 'primary';
  public resMsg: string;
  public condMsg: string = '';
  public count: number = 0;
  public countryData: any;
  passerr2;
  public cameFrom: string = "";
  public categoryData: any;
  dropdownList = [];
  passwordSpecialCharcatersAllowed = "Password special characters allowed [(){}?=.*|,':" + "_@#$%~^&+*!=\/-]"
  showTooltip = false;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalServices.isBrowser) {
      if (!document.getElementById('signup-wrap').contains(event.target) && this.clickcheck !== 0 && this.submitted === false) {
        this.globalServices.viewcontainerhelper.clear();
        this.clickcheck = 0;
      } else {
        this.clickcheck = 1;
      }
    }
  }

  constructor(public globalServices: GlobalServices, public formBuilder: FormBuilder, private httpService: ApiService, public cfr: ComponentFactoryResolver,
    private userContactService: UserContactService,public router:Router,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone) { }

  ngOnInit(): void {
    // this.googleSDK(); // comment for google signup
    // this.fbLibrary(); // comment for fb signup
    this.loadRegisterFormUser();
    if (this.globalServices.isBrowser) {
      let userDetails = JSON.parse(localStorage.getItem("userDetails"));
      this.globalServices.firstname = userDetails ? userDetails.firstName : '';
      this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
    }
  }

  tz = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone ? Intl.DateTimeFormat()?.resolvedOptions()?.timeZone : "America/New_York";
  loadRegisterFormUser() {
    if (this.globalServices.isBrowser) {
      this.registerFormUser = this.formBuilder.group({
        firstName: ["", [Validators.minLength(3), Validators.required]],
        lastName: ["", [Validators.minLength(3), Validators.required]],
        password: ["", Validators.required],
        conpassword: ["", Validators.required],
        type:[""],
        // mobile: ["", Validators.required],
        email: ["", [Validators.required, Validators.email, this.emailDomainValidator.bind(this)]],
        timezone: [this.tz, Validators.required],
        // subscriptionId: ['5f211a5ac2b8533dba508234'],
        signUpFrom:"landingPage"
      });
    }
  }
  
  checkpasswordvalid(str) {
    if(str !== '') {
      // var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      // var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{3,}$/;
      let re =/^(?=.*[0-9])(?=.*[A-Z])(?=.*[\\\[\\\](){}?\\\\|,':"_@#$%.~^&+*)(!=\/-]).*$/
      // let re = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z][a-z])(?=.*[@#$%^&+*!=]).*$/ // regex for 8 charcter  1 special, 1upper, 1 lower
      // console.log('regexTEST==>',str, re.test(str));
      // ?/\',.~][{}() ----- /\{|\}/
      if (!re.test(str)){
        this.passerr2 = "Atleast 1 Digit, 1 UpperCase and 1 special Character is required.";
      } else {
        this.passerr2 = '';
      }

      return re.test(str);
    } else {
      this.passerr2 = '';
    }
  }
  public emailDomainValidator(control:AbstractControl):{passwordValid:boolean}{
    let pass:any = control.value; 
    if(pass?.includes('@') && pass.includes('.')){
      return null;
     }else{
      return {passwordValid:true};
     }
    }
  // emailDomainValidator(control: FormControl) {
  //   let email = control.value;
  //   if (email && email.indexOf("@") != -1) {
  //     let [_, domain] = email.split("@");
  //     if (domain.length < 5) {
  //       return {
  //         emailDomain: {
  //           parsedDomain: domain
  //         }
  //       }
  //     } else {
  //       if (domain && domain.indexOf(".") != -1) {
  //         let [before, after] = domain.split(".");
  //         if (before.length < 2) {
  //           return {
  //             emailDomain: {
  //               parsedDomain: domain
  //             }
  //           }
  //         } else if (after.length < 2) {
  //           return {
  //             emailDomain: {
  //               parsedDomain: domain
  //             }
  //           }
  //         } else {
  //           return null;
  //         }
  //       } else {
  //         return {
  //           emailDomain: {
  //             parsedDomain: domain
  //           }
  //         }
  //       }
  //     }
  //   }
  //   return null;
  // }

  get formData() {
    return this.registerFormUser.controls;
  }
  ngAfterViewInit(){
  //   setTimeout(()=>{
  //   console.log(this.signupType);

  //   if(this.signupType){
  //     console.log(this.signupType,this.signupType);
  //   this.registerFormUser.get('type').setValue(this.signupType);
  //   }
  //   else{
  //   this.registerFormUser.get('type').setValue('general');
  //   }
  // },2000);
  }
  onSubmitUserForm() {
    // console.log(new Date());
    if (this.globalServices.isBrowser) {
      this.errorMessageEmail = '';
      this.condMsg = '';
      this.submitted = true;
      if (this.registerFormUser.invalid  || !this.confirmpass || !this.checkpasswordvalid(this.registerFormUser.value.password)) {
        // console.log(this.registerFormUser);
        return;
      } else {
        this.registerFormUser.patchValue({
          email: this.registerFormUser.value.email?.toLowerCase()
        })
        // console.log('onSubmitUserForm_2',this.registerFormUser, this.toFormData(this.registerFormUser.value));
        // return
        try{
          let url = "user/signup";
          this.mode = 'indeterminate';
          this.httpService.postFormData(url, this.toFormData(this.registerFormUser.value)).subscribe((response: any) => {
            if (response.success) {
              // this.globalServices.viewcontainerhelper.clear();
              this.resMsg = response.message;
              let data = { email: this.registerFormUser.value.email?.toLowerCase(), password: this.registerFormUser.value.password, type: 'normal' };
              let url = "user/login";
              localStorage.setItem("userEmail",this.registerFormUser.value.email?.toLowerCase());
              localStorage.setItem("userPass", this.registerFormUser.value.password);
              this.mode = 'indeterminate';
              this.httpService.postFormData(url, data).subscribe(response2 => {
                if (response2.success) {
                // console.log(new Date());
                  this.globalServices.isLoggedIn = true;
                  response2['data']['siteUrl'] = response2['siteUrl'];
  
                  localStorage.setItem('userDetails', JSON.stringify(response2['data']));
                  localStorage.setItem('userToken', response2['token']);
                  if(response2['isSubscriptionPurchased']){
                    localStorage.setItem('isSubscriptionPurchased', JSON.stringify(response2['isSubscriptionPurchased']));
                  }
                  this.globalServices.userDetails = JSON.parse(JSON.stringify(response2['data']));
                  this.getUserCurrentPlan();
                  this.globalServices?.isActivePlanUserHave();
                  if(response?.data?.timezone){
                    localStorage.setItem('timezone', JSON.stringify(response['data']["timezone"]));
                  }
                  if(JSON.parse(localStorage.getItem('cartdata')) !== null) {
                    let datum = [];
                    var a = [];
                    a = JSON.parse(localStorage.getItem('cartdata'));
                    a.forEach(el => {
                      let date = el.date?.split('-');
                      let dat = {
                        type: el.portal,
                        productId:el.programId,
                        productInfo: {
                          bookingStartDate: date && date[0] ? date[0] : new Date(),
                          bookingEndDate: date && date[1] ? date[1] : new Date(),
                          accommodationId: el.accommodationId,
                          noOfPeople: el.people,
                          addonsId: el.totalAddonsId,
                        },
                        pay: el.payStatus
                      };
                      datum.push(dat);
                    });
                    const headerDict = {
                      token: localStorage.getItem('userToken')
                    };
                    let newdatum = {data: datum};
  
                    let Url = "billingservice/cartservice/create";
                    this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
                      // console.log(response1);
                      // console.log(new Date());
                      localStorage.removeItem('cartdata');
                      localStorage.setItem('cartquantity', String(response1.count - 1));
                      this.globalServices.cartquantity = Number(response1.count);
                    });
                  } 
                  else {
                    localStorage.setItem('cartquantity', String(response2.count - 1));
                    this.globalServices.cartquantity = Number(response2.count);
                  }
                  // {price:price,free:'nonLoginFreeTrial'}
                  console.log(this.globalServices.direcPaymentPage);
                // if(this.globalServices.direcPaymentPage){
                //   this.mode = 'determinate';
                //   this.router.navigate['/payment'];
                  
                // }
                  let promie = new Promise((res,rej)=>{
                    if(this.globalServices.priceCheck){
                      console.log('yyyyyyyyyyyyy');
                      res(this.globalServices.priceCheck)
                    }else if(this.globalServices.direcPaymentPage){
                      console.log('rrrrrrrrrrrr');
                      res('signupNewuserMraket')
                    }else{
                      rej();
                    }
                  });
                  this.registerFormUser.reset();
                  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
                  this.globalServices.firstname = userDetails ? userDetails.firstName: '';
                  this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
                  promie.then((val)=>{
                    if(this.globalServices.direcPaymentPage){
                      this.mode = 'determinate';
                      // this.router.navigate(['/payment']);
                    }else{
                    if(this.globalServices.priceCheck){
                      // window.location.href = '/'+this.globalServices.priceCheck['free'];
                      }else{
                  this.globalServices.signupStatus=true;
                  this.globalServices.subjectTriggerForPlanPage.next(true);
                  // this.router.navigate(['/plan']);
                  // this.router.navigate(['/home']);
                      // window.location.href = '/plan';
                      }
                    }
                    this.globalServices.viewcontainerhelper.clear();
                  }).catch((err)=>{
                    this.registerFormUser.reset();
                    if(this.globalServices.direcPaymentPage){
                      this.mode = 'determinate';
                      // this.router.navigate['/payment'];
                    }else{
                    if(this.globalServices.priceCheck){
                    // window.location.href = '/'+this.globalServices.priceCheck['free'];
                    }else{
                  this.globalServices.signupStatus=true;
                  this.globalServices.subjectTriggerForPlanPage.next(true);
                  // this.router.navigate(['/plan']);
                  // this.router.navigate(['/home']);
                    // window.location.href = '/plan';
                    }
                  }
                    this.globalServices.viewcontainerhelper.clear();
                  });
                  // else{
                  // this.registerFormUser.reset();
                  // window.location.href = '/plan';
                  // this.globalServices.viewcontainerhelper.clear();
                  //  }
                  // this.loginForm.reset();
                } else {
                  // if (response['statusCode'] == '03') {
                  //   this.errorMsg = response['message'];
                  // } else {
                    this.errorMessageEmail = response2['message'];
                  // }
                }
                this.mode = 'determinate';
              },
              (error: any) => {
                this.errorMessageEmail = error;
              }
              );
            } 
            else {
              // if (response['statusCode'] == "01") {
                this.errorMessageEmail = response['message'];
              // }
            }
            this.submitted = false;
            this.mode = 'determinate';
            }, 
            (error: any) => {
              this.errorMessageEmail = error;
            }
          );
        }
        catch(error){
          this.mode = 'determinate';
          this.errorMessageEmail = error.message ? error.message : "Please try later";
        }
      }
    }
  }

  signupandlogin(logintype){
    // debugger;
    let url = "user/signup";
    this.mode = 'indeterminate';
    this.cd.detectChanges();
    this.httpService.postFormData(url, this.toFormData(this.registerFormUser.value)).subscribe((response: any) => {
      if (response.success) { 
        this.resMsg = response.message;
        let data = { email: this.registerFormUser.value.email, password: this.registerFormUser.value.password, type: logintype};
        let url = "user/login";
        localStorage.setItem("userEmail",this.registerFormUser.value.email.toLocaleLowerCase());
        localStorage.setItem("userPass", this.registerFormUser.value.password);
        // this.mode = 'indeterminate';
        this.httpService.postFormData(url, data).subscribe(response2 => {
          if (response2.success) {
            
            this.globalServices.isLoggedIn = true;
            
            response2['data']['siteUrl'] = response2['siteUrl'];

            localStorage.setItem('userDetails', JSON.stringify(response2['data']));
            localStorage.setItem('userToken', response2['token']);
            if(response2['isSubscriptionPurchased']){
              localStorage.setItem('isSubscriptionPurchased', JSON.stringify(response2['isSubscriptionPurchased']));
            }
            if(response?.data?.timezone){
              localStorage.setItem('timezone', JSON.stringify(response['data']["timezone"]));
            }
            this.globalServices.userDetails = JSON.parse(JSON.stringify(response2['data']));
            this.getUserCurrentPlan();
            this.globalServices.isActivePlanUserHave()
            if(JSON.parse(localStorage.getItem('cartdata')) !== null) {
              let datum = [];
              var a = [];
              a = JSON.parse(localStorage.getItem('cartdata'));
              a.forEach(el => {
                let date = el.date.split('-');
                let dat = {
                  type: el.portal,
                  productId:el.programId,
                  productInfo: {
                    bookingStartDate: date && date[0] ? date[0] : new Date(),
                    bookingEndDate: date && date[1] ? date[1] : new Date(),
                    accommodationId: el.accommodationId,
                    noOfPeople: el.people,
                    addonsId: el.totalAddonsId,
                  },
                  pay: el.payStatus
                };
                datum.push(dat);
              });
              const headerDict = {
                token: localStorage.getItem('userToken')
              };
              let newdatum = {data: datum};

              let Url = "billingservice/cartservice/create";
              this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
                // console.log(response1);
                localStorage.removeItem('cartdata');
                localStorage.setItem('cartquantity', String(response1.count - 1));
                // this.mode = 'determinate';
                this.globalServices.cartquantity = Number(response1.count);
              });
            }   
            else {
              // this.mode = 'determinate';
              localStorage.setItem('cartquantity', String(response2.count - 1));
              this.globalServices.cartquantity = Number(response2.count);
            }
            // {price:price,free:'nonLoginFreeTrial'}
            // console.log(this.globalServices.direcPaymentPage);
              if(this.globalServices.direcPaymentPage){
                this.mode = 'determinate';
                // this.router.navigate['/payment'];
              }
            let promie = new Promise((res,rej)=>{
              if(this.globalServices.priceCheck){
                // console.log('yyyyyyyyyyyyy');
                res(this.globalServices.priceCheck)
              }else if(this.globalServices.direcPaymentPage){
                // console.log('rrrrrrrrrrrr');
                res('signupNewuserMraket')
              }else{
                rej();
              }
            });

            this.registerFormUser.reset();
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            this.ngZone.run(() => { 
              // console.log('Outside Done!');
            this.globalServices.firstname = userDetails ? userDetails.firstName: '';
            this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
            this.globalServices.subjectTriggerForLoginDetectAtHeader.next(true);
            
            // console.log('-------------------->>>> SUBJECT');
         
            promie.then((val)=>{
              if(this.globalServices.direcPaymentPage){
                this.mode = 'determinate';
                // this.router.navigate(['/payment']);
              }else{
              if(this.globalServices.priceCheck){
                // window.location.href = '/'+this.globalServices.priceCheck['free'];
                }else{
            this.globalServices.signupStatus=true;
            this.globalServices.subjectTriggerForPlanPage.next(true);
            // this.router.navigate(['/plan']);
            // this.router.navigate(['/home']);
                // window.location.href = '/plan';
                }
              }
              this.globalServices.viewcontainerhelper.clear();
            }).catch((err)=>{
              this.registerFormUser.reset();
              if(this.globalServices.direcPaymentPage){
                this.mode = 'determinate';
                // this.router.navigate['/payment'];
              }else{
              if(this.globalServices.priceCheck){
              // window.location.href = '/'+this.globalServices.priceCheck['free'];
              }else{
            this.globalServices.signupStatus=true;
            this.globalServices.subjectTriggerForPlanPage.next(true);
            // this.router.navigate(['/plan']);
            // this.router.navigate(['/home']);
              // window.location.href = '/plan';
              }
            }
              this.globalServices.viewcontainerhelper.clear();
            });
            });
            // else{
            // this.registerFormUser.reset();
            // window.location.href = '/plan';
            // this.globalServices.viewcontainerhelper.clear();
            //  }
            // this.loginForm.reset();
          } 
          else {
            // if (response['statusCode'] == '03') {
            //   this.errorMsg = response['message'];
            // } else {
            this.mode = 'determinate';
            this.errorMessageEmail = response2['message'];
            // }
          }
        });
        // this.globalServices.viewcontainerhelper.clear();
      }
      else {
        this.mode = 'determinate';
        // if (response['statusCode'] == "01") {
        // console.log('MAJOR', response['message']);
        this.errorMessageEmail = response['message'];
        this.cd.detectChanges();
        // }
      }
      this.submitted = false;
    });
}

  toFormData<T>(formValue: T) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }

  closecomponent(): void {
    this.globalServices.viewcontainerhelper.clear();
  }

  closecomponentandlogin() {
    if (this.globalServices.isBrowser && document.getElementById("google-jssdk"))
    document.getElementById("google-jssdk").parentNode.removeChild(document.getElementById("google-jssdk"));
    this.globalServices.triggerlogin(this.globalServices.viewcontainerhelper, this.cfr);
  }
  facebooklogin() {
    if (this.globalServices.isBrowser) {
      window['FB'].login((response) => {
        this.mode = 'indeterminate';
        this.cd.detectChanges();
        // console.log('login_response', response);
        if (response.authResponse) {

          window['FB'].api('/me', {
            fields: 'last_name, first_name, email, picture'
          }, (userInfo) => {

            // console.log("user_information", userInfo);
            let url = "user/signup";
            this.registerFormUser.value.email = userInfo.email?.toLocaleLowerCase();
            this.registerFormUser.value.firstName = userInfo.first_name;
            this.registerFormUser.value.lastName = userInfo.last_name;
            this.registerFormUser.value.password = userInfo.id;
            this.registerFormUser.value.type = userInfo.type;
            this.registerFormUser.value.timezone = this.tz ? this.tz : "America/New_York";
            this.signupandlogin('facebook');
            // this.registerFormUser.value.mobile = '';
            // this.registerFormUser.value.subscriptionId = '5f211a5ac2b8533dba508234';
            // this.httpService.postFormData(url, this.toFormData(this.registerFormUser.value)).subscribe((response: any) => {
            //   this.submitted = false;
            //   if (response.success) {
            //     // this.globalServices.viewcontainerhelper.clear();
            //     this.resMsg = response.message;
            //     let data = {email: this.registerFormUser.value.email, password: this.registerFormUser.value.password};
            //     let url = "user/login";
            //     localStorage.setItem("userEmail", this.registerFormUser.value.email);
            //     localStorage.setItem("userPass", this.registerFormUser.value.password);
            //     this.mode = 'indeterminate';
            //     this.httpService.postFormData(url, data).subscribe(response2 => {
            //       if (response2.success) {
            //         this.globalServices.isLoggedIn = true;
            //         response2['data']['siteUrl'] = response2['siteUrl'];
            //
            //         localStorage.setItem('userDetails', JSON.stringify(response2['data']));
            //         localStorage.setItem('userToken', response2['token']);
            //         this.globalServices.userDetails = JSON.parse(JSON.stringify(response2['data']));
            //         if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
            //           let datum = [];
            //           var a = [];
            //           a = JSON.parse(localStorage.getItem('cartdata'));
            //           a.forEach(el => {
            //             let date = el.date.split('-');
            //             let dat = {
            //               type: 'travel',
            //               productId: el.programId,
            //               productInfo: {
            //                 bookingStartDate: date[0],
            //                 bookingEndDate: date[1],
            //                 accommodationId: el.accommodationId,
            //                 noOfPeople: el.people,
            //                 addonsId: el.totalAddonsId,
            //               },
            //               pay: el.payStatus
            //             };
            //             datum.push(dat);
            //           });
            //           const headerDict = {
            //             token: localStorage.getItem('userToken')
            //           };
            //           let newdatum = {data: datum};
            //
            //           let Url = "cartservice/create";
            //           this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
            //             console.log(response1);
            //             localStorage.removeItem('cartdata');
            //             localStorage.setItem('cartquantity', String(response1.count - 1));
            //             this.globalServices.cartquantity = Number(response1.count);
            //           });
            //         } else {
            //           localStorage.setItem('cartquantity', String(response2.count - 1));
            //           this.globalServices.cartquantity = Number(response2.count);
            //         }
            //         let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            //         this.globalServices.firstname = userDetails ? userDetails.firstName: '';
            //         this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
            //         if (this.globalServices.priceCheck['free'] == 'nonLoginFreeTrial' && this.globalServices.priceCheck['price'] == 0) {
            //           // this.router.navigate['/'];
            //           window.location.href = '/';
            //         } else if (this.globalServices.priceCheck['free'] == 'nonLoginFreeTrial' && this.globalServices.priceCheck['price'] != 0) {
            //           // this.router.navigate['/payment'];
            //           window.location.href = '/payment';
            //
            //         } else {
            //           window.location.href = '/plan';
            //         }
            //         this.mode = 'determinate';
            //         // this.loginForm.reset();
            //         // this.globalServices.viewcontainerhelper.clear();
            //       } else {
            //         // if (response['statusCode'] == '03') {
            //         //   this.errorMsg = response['message'];
            //         // } else {
            //         //   this.wrongPassword = response['message'];
            //         // }
            //       }
            //     });
            //     this.globalServices.viewcontainerhelper.clear();
            //     // this.resMsg = response.message;
            //     // window.location.href = 'plan';
            //   } else {
            //     if (response['statusCode'] === '01') {
            //       this.errorMessageEmail = response['message'];
            //     }
            //   }
            // });
            // this.globalServices.viewcontainerhelper.clear();
            // this.mode = 'determinate';
          });

        } else {
          this.mode = 'determinate';
          this.errorMessageEmail = "Login failed. Please try again.";
          this.cd.detectChanges();
          // console.log('User_login_failed');
        }
      }, {scope: 'email'});
    }
  }

  googleSDK() {

    window['googleSDKLoaded'] = () => {
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          client_id: '968207026071-ae8fso02rfo2dhf67nb51u8auh2fm5jf.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope: 'profile email'
        });
        this.prepareLoginButton();
      });
    }

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));

  }

  prepareLoginButton() {
    if (this.globalServices.isBrowser) {
      this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
        (googleUser) => {

          let profile = googleUser.getBasicProfile();
          // console.log('Token || ' + googleUser.getAuthResponse().id_token);
          // console.log('ID: ' + profile.getId());
          // console.log('Name: ' + profile.getName());
          // console.log('Image URL: ' + profile.getImageUrl());
          // console.log('Email: ' + profile.getEmail());
          //YOUR CODE HERE
          // let url = "user/signup";
          // this.mode = 'indeterminate';
          this.registerFormUser.value.email = profile.getEmail();
          this.registerFormUser.value.firstName = profile.getName();
          this.registerFormUser.value.lastName = '';
          this.registerFormUser.value.password = profile.getId();
          this.signupandlogin('google');
          // // this.registerFormUser.value.type = this.signupType?this.signupType:'general';
          // // this.registerFormUser.value.mobile = '';
          // // this.registerFormUser.value.suscriptionId = '5f211a5ac2b8533dba508234';
   8       // this.mode = 'indeterminate';
          // this.httpService.postFormData(url, this.toFormData(this.registerFormUser.value)).subscribe((response: any) => {
          //   this.submitted = false;
          //   if (response.success) {
          //     this.resMsg = response.message;
          //     let data = {email: this.registerFormUser.value.email, password: this.registerFormUser.value.password};
          //     let url = "user/login";
          //     localStorage.setItem("userEmail", this.registerFormUser.value.email);
          //     localStorage.setItem("userPass", this.registerFormUser.value.password);
          //     this.mode = 'indeterminate';
          //     this.httpService.postFormData(url, data).subscribe(response2 => {
          //       if (response2.success) {
          //         this.globalServices.isLoggedIn = true;
          //         response2['data']['siteUrl'] = response2['siteUrl'];
          //
          //         localStorage.setItem('userDetails', JSON.stringify(response2['data']));
          //         localStorage.setItem('userToken', response2['token']);
          //         this.globalServices.userDetails = JSON.parse(JSON.stringify(response2['data']));
          //         if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
          //           let datum = [];
          //           var a = [];
          //           a = JSON.parse(localStorage.getItem('cartdata'));
          //           a.forEach(el => {
          //             let date = el.date.split('-');
          //             let dat = {
          //               type: 'travel',
          //               productId: el.programId,
          //               productInfo: {
          //                 bookingStartDate: date[0],
          //                 bookingEndDate: date[1],
          //                 accommodationId: el.accommodationId,
          //                 noOfPeople: el.people,
          //                 addonsId: el.totalAddonsId,
          //               },
          //               pay: el.payStatus
          //             };
          //             datum.push(dat);
          //           });
          //           const headerDict = {
          //             token: localStorage.getItem('userToken')
          //           };
          //           let newdatum = {data: datum};
          //
          //           let Url = "cartservice/create";
          //           this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
          //             console.log(response1);
          //             localStorage.removeItem('cartdata');
          //             localStorage.setItem('cartquantity', String(response1.count - 1));
          //             this.globalServices.cartquantity = Number(response1.count);
          //           });
          //         } else {
          //           localStorage.setItem('cartquantity', String(response2.count - 1));
          //           this.globalServices.cartquantity = Number(response2.count);
          //         }
          //         let userDetails = JSON.parse(localStorage.getItem("userDetails"));
          //         this.globalServices.firstname = userDetails ? userDetails.firstName: '';
          //         this.globalServices.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
          //
          //         if (this.globalServices.priceCheck['free'] == 'nonLoginFreeTrial' && this.globalServices.priceCheck['price'] == 0) {
          //           // this.router.navigate['/'];
          //           window.location.href = baseUrls['global'];
          //         } else if (this.globalServices.priceCheck['free'] == 'nonLoginFreeTrial' && this.globalServices.priceCheck['price'] != 0) {
          //           // this.router.navigate['/payment'];
          //           window.location.href = baseUrls['global'] + 'payment';
          //
          //         } else {
          //           window.location.href = baseUrls['global'] + 'plan';
          //         }
          //         this.mode = 'determinate';
          //         // this.loginForm.reset();
          //         // this.globalServices.viewcontainerhelper.clear();
          //       } else {
          //         this.mode = 'determinate';
          //         // if (response['statusCode'] == '03') {
          //         //   this.errorMsg = response['message'];
          //         // } else {
          //         //   this.wrongPassword = response['message'];
          //         // }
          //       }
          //     });
          //     this.globalServices.viewcontainerhelper.clear();
          //
          //   } else {
          //     this.mode = 'determinate';
          //     if (response['statusCode'] == "01") {
          //       this.errorMessageEmail = response['message'];
          //     }
          //   }
          //   // this.mode = 'determinate';
          // });


        }, (error) => {
          console.log(error);
          // alert(JSON.stringify(error, undefined, 2));
        });

    }
  }


  fbLibrary() {

    (window as any).fbAsyncInit = function() {
      window['FB'].init({
        appId      : '950789175432427',
        cookie     : true,
        xfbml      : true,
        version    : 'v7.0'
      });
      window['FB'].AppEvents.logPageView();
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }

  checkpassword(){
    if(this.globalServices.isBrowser){
      if ($('#pass')[0].value === $('#confirmpass')[0].value && $('#confirmpass')[0].value !== '') {
        this.confirmpass = true;
      } else if($('#confirmpass')[0].value === ''){
        this.confirmpass = true;
      } else{
        this.confirmpass = false;
      }
    }
  }

  async inviteTokenPostCall(inviteTokenFromLocal){
    if(inviteTokenFromLocal){
      let callRes = new Promise((resolve, reject ) => {
        this.userContactService.postQuestionaireData(inviteTokenFromLocal).subscribe((resOfInviteToken: any) => {
          // console.log('inviteTokenPostCall', resOfInviteToken);
          if(resOfInviteToken){
            localStorage.removeItem('inviteToken');
            resolve('success')
          }else{
            reject('not_success')
          }
        });
      })
      let result = await callRes;
      // console.log('inviteTokenPostCall', result);
    }
  }
  userCurrentPlans = [];
  getUserCurrentPlan(){
    if(this.globalServices?.isLoggedIn){
      const userId = JSON.parse(localStorage.getItem('userDetails'))?._id;
      this.httpService.getDatabill(`billingservice/usersubscription/subs/${userId}`).subscribe((subscribePlan: any) => {
        if(subscribePlan){
          // console.log('getUserCurrentPlan', subscribePlan);
          this.userCurrentPlans = subscribePlan;
          localStorage.setItem('userSubscriptionPlan', JSON.stringify(subscribePlan))
          // 
          if(subscribePlan && subscribePlan[0]?.isExpired == 1){
            this.globalServices.moveToPlanPage.next(true);
            localStorage.setItem('moveToPlanPage', 'true');
          }
          else{
            this.globalServices.moveToPlanPage.next(false);
            localStorage.setItem('moveToPlanPage', 'false');
          }
          // 
          // this.getSubscriptionPlan();
        }
      })
    }
  }
}
